import type { VentaPendienteMaster } from '../services/ventasSeguimientoService';

/** Rutas canónicas de la aplicación (paths relativos al router). */
export const ROUTES = {
  ventas: {
    facturas: {
      list: '/ventas/facturas',
      pos: '/ventas/facturas/pos',
      /** Legacy: redirige a `pos` en App.tsx */
      nuevo: '/ventas/facturas/nuevo',
      /** Legacy: redirige a POS con `nroFormulario` en App.tsx */
      ver: (nroFormulario: number) => `/ventas/facturas/${nroFormulario}/ver`,
      /** Legacy: redirige a POS con `nroFormulario` y `editar=1` en App.tsx */
      editar: (nroFormulario: number) => `/ventas/facturas/${nroFormulario}/editar`,
    },
    pedidos: {
      list: '/ventas/pedidos',
      pos: '/ventas/pedidos/nuevo-pos',
      /** Legacy: redirige a `pos` en App.tsx */
      nuevo: '/ventas/pedidos/nuevo',
      ver: (pedidoId: number) => `/ventas/pedidos/${pedidoId}/ver`,
      editar: (pedidoId: number) => `/ventas/pedidos/${pedidoId}/editar`,
    },
    cotizaciones: {
      list: '/ventas/cotizaciones',
      pos: '/ventas/cotizaciones/nuevo-pos',
      /** Legacy: redirige a `pos` en App.tsx */
      nuevo: '/ventas/cotizaciones/nuevo',
      ver: (cotizacionId: number) => `/ventas/cotizaciones/${cotizacionId}/ver`,
      editar: (cotizacionId: number) => `/ventas/cotizaciones/${cotizacionId}/editar`,
    },
  },
} as const;

export interface VentaPendienteLocationState {
  ventaPendiente?: VentaPendienteMaster;
}

/** @deprecated Usar VentaPendienteLocationState */
export type FacturaPosLocationState = VentaPendienteLocationState;

export type PedidoPosLocationState = VentaPendienteLocationState;

export type CotizacionPosLocationState = VentaPendienteLocationState;

export interface FacturaPosPathOptions {
  pedidoId?: number;
  cotizacionId?: number;
  facturaId?: number;
}

export interface PedidoPosPathOptions {
  cotizacionId?: number;
}

/** Construye la URL de alta POS de factura con query de origen (si aplica). */
export function facturaPosPath(options?: FacturaPosPathOptions): string {
  const params = new URLSearchParams();
  if (options?.pedidoId && options.pedidoId > 0) {
    params.set('pedidoId', String(options.pedidoId));
  } else if (options?.cotizacionId && options.cotizacionId > 0) {
    params.set('cotizacionId', String(options.cotizacionId));
  } else if (options?.facturaId && options.facturaId > 0) {
    params.set('facturaId', String(options.facturaId));
  }
  const query = params.toString();
  return query ? `${ROUTES.ventas.facturas.pos}?${query}` : ROUTES.ventas.facturas.pos;
}

/** URL POS para ver una factura existente (solo lectura). */
export function facturaPosVerPath(nroFormulario: number): string {
  return `${ROUTES.ventas.facturas.pos}?nroFormulario=${nroFormulario}`;
}

/** URL POS para editar una factura existente. */
export function facturaPosEditarPath(nroFormulario: number): string {
  return `${ROUTES.ventas.facturas.pos}?nroFormulario=${nroFormulario}&editar=1`;
}

/** Construye la URL de alta POS de pedido con query de origen (si aplica). */
export function pedidoPosPath(options?: PedidoPosPathOptions): string {
  const params = new URLSearchParams();
  if (options?.cotizacionId && options.cotizacionId > 0) {
    params.set('cotizacionId', String(options.cotizacionId));
  }
  const query = params.toString();
  return query ? `${ROUTES.ventas.pedidos.pos}?${query}` : ROUTES.ventas.pedidos.pos;
}
